import { useEffect } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import { apiHolder as api } from 'api';
const eventApi = api.api.getEventApi();
const useMsgCallback = (eventName, callback) => {
    useEffect(() => {
        const id = eventApi.registerSysEventObserver(eventName, {
            func: e => {
                unstable_batchedUpdates(() => {
                    callback && callback(e);
                });
            },
        });
        return () => {
            eventApi.unregisterSysEventObserver(eventName, id);
        };
    }, []);
};
export default useMsgCallback;
